/**
 * - Added `options`
 * - Added `options.skipParsing`
 */
/* eslint-disable @next/next/no-img-element */
// content recommendation widget ideally using svg.
import { RenderContent } from '@/components/blocks/RenderContent';
import { ProcessedContent } from '@/data/types/Marketing';
import { MouseEvent } from 'react';

export const renderContent = (
	content?: ProcessedContent,
	onClick?: (_event: MouseEvent) => Promise<void>,
	options?: { skipParsing?: boolean }
) => (
	<RenderContent
		key={content?.contentId}
		content={content}
		onClick={onClick}
		skipParsing={options?.skipParsing}
	/>
);
